// Never "Group 2": that is the array index, and it renumbers whenever a
// group is removed.
import { groupModeLabel } from '@apps/web/lib/outreach_shift_ordering';

const MAX_NAMED_CLIENTS = 2;
const SEPARATOR = ' · ';

/** Who the group's shifts are for and how many, without its mode. */
export function groupReferenceSubject({
    clientNames,
    shiftCount,
}: Readonly<{
    readonly clientNames: ReadonlyArray<string>;
    readonly shiftCount: number;
}>): string {
    const named = clientNames.slice(0, MAX_NAMED_CLIENTS);
    const remaining = clientNames.length - named.length;
    const clients =
        remaining > 0 ? `${named.join(', ')} +${remaining}` : named.join(', ');
    const shifts = `${shiftCount} ${shiftCount === 1 ? 'shift' : 'shifts'}`;
    return [clients, shifts].filter((part) => part !== '').join(SEPARATOR);
}

export function groupReferenceLabel({
    clientNames,
    shiftCount,
    groupMode,
}: Readonly<{
    readonly clientNames: ReadonlyArray<string>;
    readonly shiftCount: number;
    readonly groupMode: 'all' | 'any';
}>): string {
    return [
        groupReferenceSubject({ clientNames, shiftCount }),
        groupModeLabel(groupMode),
    ].join(SEPARATOR);
}
